import {
  UPDATE_EMAIL,
  UPDATE_PASSWORD,
  UPDATE_EMAIL_RECEIVES,
  AGREE_TO_TERMS,
  TOGGLE_AGREE_TO_TERMS,
  SHOW_USER,
} from './types';

import { createReduxAction } from '../utils';

import { Details } from './api';

export const approveTermsOfServices = createReduxAction(AGREE_TO_TERMS);
export const toggleTermsOfServices = createReduxAction(TOGGLE_AGREE_TO_TERMS);

export const showUserAction = (setSubmitting, setErrors) => async dispatch => {
  const response = await Details.show();
  if (!response.error) {
    dispatch({ type: SHOW_USER, payload: response });
    return { status: response.status };
  } else {
    return response;
  }
};

export const updateEmailAction = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Details.updateEmail(body);
  if (!response.error) {
    dispatch({ type: UPDATE_EMAIL, payload: response.data });
    return { status: response.status };
  } else {
    return response;
  }
};

export const updatePasswordAction = (
  body,
  setSubmitting,
  setErrors,
) => async dispatch => {
  const response = await Details.updatePassword(body);
  if (!response.error) {
    dispatch({ type: UPDATE_PASSWORD, payload: response.data });
    setSubmitting(false);
    return { status: response.status };
  } else {
    if (response.textError.current_password) {
      setErrors({
        currentPassword: `Current password ${
          response.textError.current_password[0]
        }`,
      });
    }
    setSubmitting(false);
    return response;
  }
};

export const updateReceivesAction = body => async dispatch => {
  const response = await Details.updateReceives(body);
  if (!response.error) {
    dispatch({ type: UPDATE_EMAIL_RECEIVES, payload: response.data });
    return { status: response.status };
  } else {
    return response;
  }
};

export const sendEmailConfirmation = () => async dispatch => {
  const response = await Details.confirmEmail();
  return response;
};



// WEBPACK FOOTER //
// ./src/store/modules/profileDetails/actions.js